/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type BootstrapDataImportProjectV2DataSourceInput = {
  dataSource: DataSourceInImportProjectCreateInput;
  schemaMappings: Array<BootstrapDataImportProjectV2DataSourceSchemaMappingInput>;
};

export type BootstrapDataImportProjectV2DataSourceSchemaMappingInput = {
  categoryId: string;
  categoryPropertyName?: string | null | undefined;
  dataSourcePropertyLabel?: string | null | undefined;
  fkResolver?: SetupDataImportJobsSchemaMappingForeignKeyResolver | null | undefined;
  type: SetupDataImportJobsSchemaMappingType;
  variantKey?: string | null | undefined;
};

export type BootstrapDataImportProjectV2Input = {
  dataImportProjectId: string;
  dataSources: Array<BootstrapDataImportProjectV2DataSourceInput>;
  tenantId: string;
};

export type DataSourceInImportProjectCreateInput = {
  dataSourcePropertySchemas?: Array<PropertySchemaAssociationInput> | null | undefined;
  dataSourceTemplateId?: string | null | undefined;
  gSheetsConfig?: GSheetsConfigInput | null | undefined;
  importProjectId: string;
  jsonData?: Types.JsonObject | null | undefined;
  name: string;
  referenceIds?: Array<string> | null | undefined;
  tenantId: string;
};

export type GSheetsConfigInput = {
  sheetName?: string | null | undefined;
};

export type I18nLabelCanonicalInput = {
  locale: string;
  value: string;
};

export type I18nLabelInput = {
  canonical?: Array<I18nLabelCanonicalInput> | null | undefined;
  en?: string | null | undefined;
  ja?: string | null | undefined;
};

export type JsonQueryInput = {
  array_contains?: unknown;
  equals?: unknown;
  not?: unknown;
  path: Array<string>;
  string_ends_with?: string | null | undefined;
  string_starts_with?: string | null | undefined;
};

export type PropertyAttributeTypeId =
  | 'date'
  | 'endDate'
  | 'title';

export type PropertySchemaAssociationInput = {
  description?: string | null | undefined;
  id?: string | null | undefined;
  name: string;
  position?: number | null | undefined;
  propertyAttributeTypeId?: PropertyAttributeTypeId | null | undefined;
  propertySchema: PropertySchemaUpsertInput;
  required?: boolean | null | undefined;
  unique?: boolean | null | undefined;
};

export type PropertySchemaType =
  | 'bool'
  | 'dag'
  | 'date'
  | 'formula'
  | 'gdtf'
  | 'i18nLabel'
  | 'i18nLabels'
  | 'linkEntities'
  | 'linkEntity'
  | 'linkGeoItems'
  | 'linkRelation'
  | 'linkRelations'
  | 'media'
  | 'multiSelect'
  | 'number'
  | 'numbers'
  | 'rollup'
  | 'select'
  | 'string'
  | 'strings'
  | 'url';

export type PropertySchemaUpsertInput = {
  id?: string | null | undefined;
  propertyTypeId: PropertySchemaType;
  propertyValueDagId?: string | null | undefined;
  propertyValueLinkFilterId?: string | null | undefined;
  selectOptions?: Array<PropertySelectOptionInput> | null | undefined;
  urlAllowList?: Array<PropertyUrlAllowListItem> | null | undefined;
};

export type PropertySelectOptionInput = {
  id?: string | null | undefined;
  label?: I18nLabelInput | null | undefined;
  value: string;
};

export type PropertyUrlAllowListItem = {
  id?: string | null | undefined;
  regex?: string | null | undefined;
  value?: string | null | undefined;
};

export type SetupDataImportJobsSchemaMappingForeignKeyConstraint = {
  fkColumnLabel: string;
  linkedCategoryName: string;
  linkedInstanceLabel: string;
};

export type SetupDataImportJobsSchemaMappingForeignKeyQuery = {
  categoryNames?: Array<string> | null | undefined;
  evidenceIdsFilter?: Array<string> | null | undefined;
  evidenceMetadata?: JsonQueryInput | null | undefined;
  evidenceProperties?: JsonQueryInput | null | undefined;
  or?: Array<SetupDataImportJobsSchemaMappingForeignKeyQuery> | null | undefined;
  recordId?: string | null | undefined;
  recordMetadata?: JsonQueryInput | null | undefined;
  recordProperties?: JsonQueryInput | null | undefined;
  referenceIdsFilter?: Array<string> | null | undefined;
};

export type SetupDataImportJobsSchemaMappingForeignKeyResolver = {
  fkConstraint?: SetupDataImportJobsSchemaMappingForeignKeyConstraint | null | undefined;
  query: SetupDataImportJobsSchemaMappingForeignKeyQuery;
};

export type SetupDataImportJobsSchemaMappingType =
  | 'PROPERTIES'
  | 'RELATION_SOURCE'
  | 'RELATION_TARGET';

export type BootstrapDataImportProjectV2MutationVariables = Exact<{
  input: Types.BootstrapDataImportProjectV2Input;
}>;


export type BootstrapDataImportProjectV2Mutation = { cnutBootstrapDataImportProjectV2:
    | { __typename: 'BootstrapDataImportProjectV2Output', dataImportProjectId: string, dataSourceIds: Array<string>, batchEvidencesJobIds: Array<string>, batchChangeRequestsJobIds: Array<string> }
    | { __typename: 'ClientError', code: string, message: string }
    | { __typename: 'ValidationError', code: string, message: string, fields: Array<{ __typename: 'ValidationErrorField', path: string, message: string, code: string | null }> }
   };


export const BootstrapDataImportProjectV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BootstrapDataImportProjectV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BootstrapDataImportProjectV2Input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutBootstrapDataImportProjectV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BootstrapDataImportProjectV2Output"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataImportProjectId"}},{"kind":"Field","name":{"kind":"Name","value":"dataSourceIds"}},{"kind":"Field","name":{"kind":"Name","value":"batchEvidencesJobIds"}},{"kind":"Field","name":{"kind":"Name","value":"batchChangeRequestsJobIds"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BootstrapDataImportProjectV2Mutation, BootstrapDataImportProjectV2MutationVariables>;